import React, { useContext, useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Option from './Option';
import { ScoreContext } from './Root';

const Questions = ({ question, index }) => {
   const { options, id, correctAnswer } = question;
   console.log();
   const [score, setScore] = useContext(ScoreContext);
   const [toggle, setToggle] = useState(false);
   const handleOption = (select) => {
      if (select === correctAnswer) {
         console.log('correct');
         setScore(score + 1);
         return toast.success('Correct answer', {
            position: 'top-right',
            autoClose: 5000,
         });
      } else {
         return toast.warning('Wrong answer', {
            position: 'top-right',
            autoClose: 5000,
         });
      }
   };
   return (
      <div className="border p-14 space-y-6  mx-auto ">
         <div className="flex justify-around">
            <div className="text-3xl font-semibold text-teal-500 p-5">
               Quiz: {index + 1} {question.question.split('<p>').join('').split('</p>').join('')}
            </div>
            <div onClick={() => setToggle(!toggle)} className="cursor-pointer">
               {!toggle ? (
                  <svg
                     xmlns="http://www.w3.org/2000/svg"
                     fill="none"
                     viewBox="0 0 24 24"
                     strokeWidth={1.5}
                     stroke="currentColor"
                     className="w-6 h-6"
                  >
                     <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
                     />
                     <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
               ) : (
                  <svg
                     xmlns="http://www.w3.org/2000/svg"
                     fill="none"
                     viewBox="0 0 24 24"
                     strokeWidth={1.5}
                     stroke="currentColor"
                     className="w-6 h-6"
                  >
                     <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
                     />
                  </svg>
               )}
            </div>
         </div>
         <div className="space-y-4">
            {options.map((option, index) => (
               <Option key={index} option={option} handleOption={handleOption} question={question}>
                  {option}
               </Option>
            ))}
            <h2 className={`${toggle ? 'inline' : 'hidden'} lg:text-xl bg-teal-200  lg:p-6 rounded  `}>
               Answer: {correctAnswer}
            </h2>
            <ToastContainer></ToastContainer>
         </div>
      </div>
   );
};

export default Questions;
